// extracted by mini-css-extract-plugin
module.exports = {"main-component":"delayIndicator_main-component__yic4K"};